import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/VersionButton.tsx";
import "core-js/modules/es.string.trim.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { memo, useEffect, useRef, useState } from 'react';
import { Cancel, Done, FolderWithoutSubstrate, HistoryBack, IconButton, LongText, TextField, Tooltip, Padlock } from '@gmini/ui-kit';
import { getVersionDateLabel } from "../../helpers/versionDateCommon";
import { VersionContainer, VersionContainerWrap, VersionInfo, Title, TitleWrap, VersionNumber, VersionDate, EditButton, TitlePanel, EditActionWrap, EditWrap, CancelButton, DoneButton, IconSpinner, VersionName, ReadOnlyMessage, ReadOnlyMessageText } from "./VersionButton.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var VersionButton = /*#__PURE__*/memo(function (_ref) {
  var isActualVersion = _ref.isActualVersion,
      onClick = _ref.onClick,
      currentVersion = _ref.currentVersion,
      versionCreated = _ref.versionCreated,
      versionName = _ref.versionName,
      pending = _ref.pending,
      title = _ref.title,
      onRename = _ref.onRename,
      renamePending = _ref.renamePending,
      renderVersionBrand = _ref.renderVersionBrand;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editable = _useState2[0],
      setEditable = _useState2[1];

  var _useState3 = useState(title),
      _useState4 = _slicedToArray(_useState3, 2),
      titleState = _useState4[0],
      setTitleState = _useState4[1];

  var inputTitleRef = useRef(null);
  var versionDate = getVersionDateLabel(versionCreated, isActualVersion);

  var onCopyText = function onCopyText() {
    navigator.clipboard.writeText(title);
  };

  useEffect(function () {
    if (editable) {
      var _inputTitleRef$curren;

      (_inputTitleRef$curren = inputTitleRef.current) === null || _inputTitleRef$curren === void 0 ? void 0 : _inputTitleRef$curren.focus();
    }
  }, [editable]);

  var onRenameHandler = function onRenameHandler() {
    setEditable(false);
    onRename(titleState.trim());
  };

  var onCancelRename = function onCancelRename() {
    setTitleState(title);
    setEditable(false);
  };

  return /*#__PURE__*/_jsxs(VersionContainerWrap, {
    children: [/*#__PURE__*/_jsxs(VersionContainer, {
      children: [editable && /*#__PURE__*/_jsxs(EditWrap, {
        children: [/*#__PURE__*/_jsx(TextField, {
          value: titleState,
          onChange: function onChange(value) {
            return setTitleState(value);
          },
          inputRef: inputTitleRef,
          clearable: true
        }), /*#__PURE__*/_jsxs(EditActionWrap, {
          children: [/*#__PURE__*/_jsx(CancelButton, {
            onClick: onCancelRename,
            children: /*#__PURE__*/_jsx(Cancel, {
              width: "24px",
              height: "24px",
              color: "#D9575E"
            })
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: titleState.trim().length ? '' : 'Введите название',
            children: /*#__PURE__*/_jsx(DoneButton, {
              disabled: !titleState.trim().length,
              onClick: onRenameHandler,
              children: /*#__PURE__*/_jsx(Done, {
                width: "20px",
                height: "20px",
                color: "#4C5ECF"
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(TitlePanel, {
        children: [/*#__PURE__*/_jsx(TitleWrap, {
          onClick: onCopyText,
          children: /*#__PURE__*/_jsx(Tooltip, {
            enterDelay: 400,
            title: "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435 \u043C\u044B\u0448\u044C\u044E, \u0447\u0442\u043E\u0431\u044B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
            children: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(FolderWithoutSubstrate, {
                opacity: "1",
                width: "20px",
                height: "16px",
                color: "#353B60"
              }), /*#__PURE__*/_jsx(Title, {
                children: /*#__PURE__*/_jsx(LongText, {
                  partSize: 30,
                  withoutRightText: true,
                  withoutTooltip: true,
                  children: ".../".concat(title)
                })
              })]
            })
          })
        }), isActualVersion && (renamePending ? /*#__PURE__*/_jsx(IconSpinner, {
          size: 20
        }) : /*#__PURE__*/_jsx(Tooltip, {
          title: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C",
          children: /*#__PURE__*/_jsx(EditButton, {
            "data-test-id": "renameEntityInside",
            onClick: function onClick() {
              return setEditable(true);
            },
            width: "20px",
            height: "20px"
          })
        }))]
      }), /*#__PURE__*/_jsxs(VersionInfo, {
        children: [renderVersionBrand ? renderVersionBrand({
          currentVersion: currentVersion,
          isActualVersion: isActualVersion,
          versionDate: versionDate,
          versionName: versionName
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(VersionNumber, {
            "data-test-id": "entityVersion",
            children: "V00".concat(currentVersion)
          }), versionName && /*#__PURE__*/_jsx(VersionName, {
            children: versionName
          }), /*#__PURE__*/_jsx(VersionDate, {
            children: versionDate
          })]
        }), !isActualVersion && /*#__PURE__*/_jsxs(ReadOnlyMessage, {
          children: [/*#__PURE__*/_jsx(Padlock, {}), /*#__PURE__*/_jsx(ReadOnlyMessageText, {
            children: "\u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u0435\u043D\u0438\u0435"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0432\u0435\u0440\u0441\u0438\u0439",
      enterDelay: 400,
      leaveDelay: 0,
      children: /*#__PURE__*/_jsx(IconButton, {
        disabled: pending,
        onClick: onClick,
        "data-test-id": "viewVersionsHistory",
        children: /*#__PURE__*/_jsx(HistoryBack, {})
      })
    })]
  });
});
VersionButton.displayName = 'VersionButton';